import memoize from 'lodash/memoize';
import { selectPagination } from 'redux/helpers/pagination';
import { createSelector } from 'reselect';

const getPulseSurveyEntities = ({ entities: { pulseSurveys } }) => pulseSurveys;
const getPulseSurveySelector = createSelector([getPulseSurveyEntities], entities => memoize(id => entities?.[id]));
const getPulseSurveysPagination = ({ pulse: { allPulseSurveys } }) => selectPagination(allPulseSurveys, null, 'pulseSurveyIds');
const getPulseSurveys = createSelector(
  [getPulseSurveysPagination, getPulseSurveySelector],
  ({ pulseSurveyIds }, getPulseSurvey) => pulseSurveyIds.map(getPulseSurvey),
);
const getActivePulseSurveySelector = ({ pulse: { activePulseSurvey } }) => activePulseSurvey;
const getActivePulseSurveyFetchedAtSelector = ({ pulse: { activePulseSurveyFetchedAt } }) => activePulseSurveyFetchedAt;

const getDepartments = ({ pulse: { departments } }) => departments;
const getLocations = ({ pulse: { locations } }) => locations;

const getPulseSurveyResponseEntities = ({ entities: { pulseSurveyResponses } }) => pulseSurveyResponses;
const getPulseSurveyResponseSelector = createSelector([getPulseSurveyResponseEntities], entities => memoize(id => entities?.[id]));
const getPulseSurveyResponsesPagination = ({ pulse: { allPulseSurveyResponses } }) => selectPagination(allPulseSurveyResponses, null, 'pulseSurveyResponseIds');
const getPulseSurveyResponses = createSelector(
  [getPulseSurveyResponsesPagination, getPulseSurveyResponseSelector],
  ({ pulseSurveyResponseIds }, getPulseSurveyResponse) => pulseSurveyResponseIds.map(getPulseSurveyResponse),
);

const getPulseSurveyOverviewAnalyticsEntities = ({ entities: { pulseSurveysOverviewAnalytics } }) => pulseSurveysOverviewAnalytics;
const getPulseSurveyOverviewAnalyticsSelector = createSelector([getPulseSurveyOverviewAnalyticsEntities], entities => memoize(id => entities?.[id]));

const getPulseSurveyDetailedAnalyticsEntities = ({ entities: { pulseSurveysDetailedAnalytics } }) => pulseSurveysDetailedAnalytics;
const getPulseSurveyDetailedAnalyticsSelector = createSelector([getPulseSurveyDetailedAnalyticsEntities], entities => memoize(groupByValue => entities?.[groupByValue]));
const getPulseSurveysDetailedAnalyticsPagination = ({ pulse: { allPulseSurveyDetailedAnalytics } }) => selectPagination(allPulseSurveyDetailedAnalytics, null, 'pulseSurveyDetailedAnalyticsGroupByValues');
const getPulseSurveyDetailedAnalytics = createSelector(
  [getPulseSurveysDetailedAnalyticsPagination, getPulseSurveyDetailedAnalyticsSelector],
  ({ pulseSurveyDetailedAnalyticsGroupByValues }, getPulseSurveyDetailedAnalyticsItem) => pulseSurveyDetailedAnalyticsGroupByValues.map(getPulseSurveyDetailedAnalyticsItem),
);

const getPulseScaleEntities = ({ entities: { pulseScales } }) => pulseScales;
const getPulseScales = createSelector([getPulseScaleEntities], entities => Object.values(entities || {}));

const getPulseSurveyPeriodEntities = ({ entities: { pulseSurveyPeriods } }) => pulseSurveyPeriods;
const getPulseSurveyPeriods = createSelector([getPulseSurveyPeriodEntities], entities => memoize((pulseSurveyId) => Object.values(entities || {}).filter(e => e?.pulseSurveyId === pulseSurveyId)));

const getPulseSurveyScheduleEntities = ({ entities: { pulseSurveySchedules } }) => pulseSurveySchedules;
const getPulseSurveySchedules = createSelector([getPulseSurveyScheduleEntities], entities => memoize(pulseSurveyId => Object.values(entities || {}).filter(e => e?.pulseSurveyId === pulseSurveyId)));
const getPulseSurveyScheduleSelector = createSelector([getPulseSurveyScheduleEntities], entities => memoize(id => entities?.[id]));

export default {
  getPulseSurveySelector,
  getPulseSurveysPagination,
  getPulseSurveys,
  getActivePulseSurveySelector,
  getActivePulseSurveyFetchedAtSelector,

  getDepartments,
  getLocations,

  getPulseSurveyResponseSelector,
  getPulseSurveyResponsesPagination,
  getPulseSurveyResponses,

  getPulseSurveyOverviewAnalyticsSelector,

  getPulseSurveyDetailedAnalyticsSelector,
  getPulseSurveysDetailedAnalyticsPagination,
  getPulseSurveyDetailedAnalytics,

  getPulseScales,

  getPulseSurveyPeriods,

  getPulseSurveySchedules,
  getPulseSurveyScheduleSelector,
};
